import axios from 'axios';

const BASE_URL = '/profiles';
const CONTENT_FILTERS_URL = 'user_content_filters';

export function findProfiles(params = {}) {
  return axios.get(`${BASE_URL}`, { params });
}

export function getDashboardProfiles(params) {
  return axios.get(`${BASE_URL}/dashboard_profiles`, { params });
}

export function getProfile(profileId) {
  return axios.get(`${BASE_URL}/${profileId}`);
}

export function createProfile(params) {
  return axios.post(`${BASE_URL}`, params);
}

export function updateProfile(profileId, params) {
  return axios.patch(`${BASE_URL}/${profileId}`, { profile: { ...params } });
}

export function updateSubcategoryRestriction(profileId, params) {
  return axios.patch(
    `${BASE_URL}/${profileId}/sub_category_restrictions`,
    params
  );
}

export function updateCategoryRestriction(profileId, params) {
  return axios.patch(`${BASE_URL}/${profileId}/category_restrictions`, params);
}

export function findCategories(profileId) {
  return axios.get(`${BASE_URL}/${profileId}/categories`);
}

export function findCustomCategories(profileId, query) {
  return axios.get(`${BASE_URL}/${profileId}/custom_categories?query=${query}`);
}

export function createCustomCategory(profileId, params) {
  return axios.post(`${BASE_URL}/${profileId}/custom_categories`, params);
}

export function updateCustomCategory(profileId, customCategoryId, params) {
  return axios.patch(
    `${BASE_URL}/${profileId}/custom_categories/${customCategoryId}`,
    params
  );
}

export function deleteCustomCategory(profileId, customCategoryId) {
  return axios.delete(
    `${BASE_URL}/${profileId}/custom_categories/${customCategoryId}`
  );
}

export function findContentFilters(profileId, query) {
  return axios.get(
    `${BASE_URL}/${profileId}/${CONTENT_FILTERS_URL}?query=${query}`
  );
}

export function updateContentFilter(profileId, contentFilterId, params) {
  return axios.patch(
    `${BASE_URL}/${profileId}/${CONTENT_FILTERS_URL}/${contentFilterId}`,
    params
  );
}

export function deleteContentFilter(profileId, contentFilterId) {
  return axios.delete(
    `${BASE_URL}/${profileId}/${CONTENT_FILTERS_URL}/${contentFilterId}`
  );
}

export function createContentFilter(profileId, params) {
  return axios.post(`${BASE_URL}/${profileId}/${CONTENT_FILTERS_URL}`, params);
}

export function allowAllContentFilters(profileId) {
  return axios.post(
    `${BASE_URL}/${profileId}/${CONTENT_FILTERS_URL}/allow_all`
  );
}

export function deleteProfile(profileId) {
  return axios.delete(`${BASE_URL}/${profileId}`);
}

export function duplicateProfile(params) {
  return axios.post(`${BASE_URL}/duplicate`, params);
}

export function assignDevices(profileId, params) {
  return axios.patch(`${BASE_URL}/${profileId}/assign_devices`, params);
}

export function assignDevicesInterfaces(profileId, params) {
  return axios.patch(
    `${BASE_URL}/${profileId}/assign_devices_interfaces`,
    params
  );
}

export function assignSslVpnDevicesInterfaces(profileId, params) {
  return axios.patch(
    `${BASE_URL}/${profileId}/assign_ssl_vpn_devices_interfaces`,
    params
  );
}

export function getImpliedRulesData(profileId) {
  return axios.get(`${BASE_URL}/${profileId}/implied_rules_data`);
}

export function getVpnIpsecNetworks(profileId) {
  return axios.get(`${BASE_URL}/${profileId}/vpn_ipsec_networks`);
}
